import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-829d2528")

_pushScopeId("data-v-829d2528")
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", { class: "mb-2" }, "Pembayaran Saat Ini", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = {
  class: "d-flex justify-content-center align-items-center mt-4",
  style: {"height":"calc(100% - 110px)"}
}
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = { class: "text-primary mt-4" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center mt-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_9 = { style: {"text-align":"center"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.value.toFixed(2)) + "%", 1)
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("span", {
          class: [_ctx.changed >= 0 ? 'gbadgesuc' : 'gbadgeerr', "custooltip"]
        }, [
          _createTextVNode(_toDisplayString(_ctx.changed.toFixed(2)) + "% YoY ", 1),
          _createVNode("span", {
            class: "tooltiptext",
            innerHTML: _ctx.tooltip
          }, null, 8, ["innerHTML"])
        ], 2)
      ])
    ])
  ]))
})